//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum Locales {
  'EN_US' = 'en-us',
  'FR_FR' = 'fr-fr',
  'IT_IT' = 'it-it',
  'DE_DE' = 'de-de',
  'PL_PL' = 'pl-pl',
  'RU_RU' = 'ru-ru',
  'ES_ES' = 'es-es',
  'EN_GB' = 'en-gb',
  'EN_CA' = 'en-ca',
  'FR_CA' = 'fr-ca',
  'EN_EU' = 'en-eu',
  'PT_BR' = 'pt-br',
  'ES_MX' = 'es-mx',
  'ES_US' = 'es-us',
  'SV_SE' = 'sv-se',
  'NL_NL' = 'nl-nl',
  'DA_DK' = 'da-dk',
}
